import { Guid } from 'guid-typescript';

export class ProcessoTagRequest {
    processoId: Guid;
    tags: Guid[]
}